






import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class ChangelogView extends Vue {
  async created() {
    this.$emit('showPreloader');
    // code..
    this.$emit('loadingFinished');
  }
}
